type InputFieldProps = {
  placeholder?: string;
  className?: string;
  unit?: string;
  error?: string;
  value?: string;
  onChange?: (value: string) => void;
};

const InputField = ({
  placeholder = "",
  className = "",
  unit = "",
  error,
  value,
  onChange,
}: InputFieldProps) => {
  const hasError = Boolean(error);
  return (
    <div className="flex flex-col w-full gap-1">
      <div className="flex w-full">
        <input
          type="number"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          className={[
            "inline-flex items-start max-w-75 p-4 w-full border-2 rounded-l-[10px] rounded-r-none",

            "focus:border-2 focus:outline-none",

            "placeholder:text-[#828282]",

            hasError && "border-[#FF0000] focus:border-[#FF0000]",
            !hasError && "border-[#333] focus:border-[#666]",

            className,
          ].join(" ")}
        />
        <span className="max-w-25 w-full bg-[#333] p-4 text-white rounded-r-[10px] rounded-l-none flex justify-center">
          {unit}
        </span>
      </div>
      {hasError && <p className="text-[12px] text-[#FF0000]">{error}</p>}
    </div>
  );
};

export default InputField;
